export var sanitizeUrl = function(param) {
    var _param_pathname = param.pathname, pathname = _param_pathname === void 0 ? "" : _param_pathname, _param_search = param.search, search = _param_search === void 0 ? "" : _param_search, _param_hash = param.hash, hash = _param_hash === void 0 ? "" : _param_hash;
    var sanitizedPathname = pathname;
    var sanitizedSearch = search;
    // Ensure there is a leading slash
    if (sanitizedPathname[0] !== "/") {
        sanitizedPathname = "/".concat(sanitizedPathname);
    }
    // Ensure there is a leading question mark in search
    if (sanitizedSearch && sanitizedSearch[0] !== "?") {
        sanitizedSearch = "?".concat(sanitizedSearch);
    }
    return "".concat(sanitizedPathname).concat(sanitizedSearch).concat(hash);
};
